import { render, staticRenderFns } from "./roleSetting.vue?vue&type=template&id=6510ff2c&scoped=true&"
import script from "./roleSetting.vue?vue&type=script&lang=ts&"
export * from "./roleSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510ff2c",
  null
  
)

export default component.exports